<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark>
        <v-btn @click="routerBack" style="position: absolute" icon>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-toolbar-title class="text-center">{{ t('parentAdd.title') }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
    </div>

    <v-container fluid>
      <v-form ref="post_family_by_id_form">
        <div>
          <p class="body-2 blue-grey--text">{{ t('parentAdd.emailLabel') }}</p>
          <v-text-field v-model="email" outlined dense></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">{{ t('parentAdd.parentTypeLabel') }}</p>
          <v-select
            v-model="parentType"
            :items="parentTypes"
            item-title="text"
            item-value="value"
            outlined
            dense></v-select>
        </div>

        <div class="my-2">
          <p class="mb-2 body-2">{{ t('parentAdd.noticeSignup') }}</p>
          <p class="mb-4 body-2">{{ t('parentAdd.noticeSpam') }}</p>
        </div>

        <div class="d-flex justify-center my-5">
          <v-btn
            @click="postFamilyById"
            :loading="btnLoading"
            color="primary"
            block>
            {{ t('parentAdd.submit') }}
          </v-btn>
        </div>
      </v-form>
    </v-container>

    <div class="pa-1 today-wrapper">
      <h5>{{ t('parentAdd.invitedEmails') }}</h5>
    </div>
    <div>
      <v-list density="compact">
        <!-- 1. key は template タグに移動し、v-list-item-group は削除 -->
        <template v-for="(i, index) in inviteInfo" :key="i.inviteEmail">
          
          <v-list-item>
            <!-- 2. v-list-item-content 廃止 → title を直下に配置 -->
            <v-list-item-title class="font-weight-bold subtitle-1">
              {{ i.inviteEmail }}
            </v-list-item-title>
          </v-list-item>

          <v-divider />
        </template>
      </v-list>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { Toast } from '@/service/SweetAlert';
import rules from '@/service/ValidRules';

import { meModule } from '@/store/entityModules/me';
import { familyModule } from '@/store/entityModules/family';
import { t } from '@/i18n';

// model
import type { VForm } from 'vuetify/components';
import { PostFamilyByIdRequest } from '@/model/Family';
import { Me } from '@/model/Others/Me';
import { InviteInfo, ParentMeResponse } from 'chaild-entity/lib';

interface DataType {
  email: string;
  parentType: string;
  btnLoading: boolean;
}

export default defineComponent({
  computed: {
    family() {
      return familyModule.family;
    },
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).post_family_by_id_form;
    },
    parentTypes(): Array<{ text: string; value: string }> {
      return [
        { text: this.t('parentAdd.parentType.mother'), value: 'mother' },
        { text: this.t('parentAdd.parentType.father'), value: 'father' },
        { text: this.t('parentAdd.parentType.grandma'), value: 'grandma' },
        { text: this.t('parentAdd.parentType.granpa'), value: 'granpa' },
        { text: this.t('parentAdd.parentType.uncle'), value: 'uncle' },
        { text: this.t('parentAdd.parentType.aunt'), value: 'aunt' },
        { text: this.t('parentAdd.parentType.other'), value: 'other' },
      ];
    },
    me() {
      return meModule.me;
    },
    inviteInfo(): InviteInfo[] {
      if (this.me && this.family) {
        const familyId = this.family.familyId;
        const selectedFamilyIndex = this.me.families.findIndex(
          (f) => f.familyId === familyId,
        );
        const selectedFamily = this.me.families[selectedFamilyIndex];
        return selectedFamily.inviteHistory;
      }
      return [];
    },
  },

  data: (): DataType => ({
    email: '',
    parentType: '',
    btnLoading: false,
  }),

  methods: {
    t,
    routerBack() {
      this.$router.replace('/setting/family');
    },
    async postFamilyById() {
      const { valid } = await this.form.validate();
      if (valid && this.family) {
        this.btnLoading = true;
        try {
          const response = await familyModule.postFamilyById({
            familyId: String(this.family.familyId),
            email: this.email,
            parentType: this.parentType,
          });
          meModule.fetchMe();
          Toast.fire({
            icon: 'success',
            title: this.t('parentAdd.inviteSuccess'),
          });
          this.btnLoading = false;
        } catch (error) {
          this.btnLoading = false;
        }
      }
    },
  },

  mounted() {
    meModule.fetchMe();
  },
});
</script>
<style lang="scss" scoped>
/* ===== レイアウト ===== */
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(55px + env(safe-area-inset-top));
}
.wrapper {
  .today-wrapper {
    color: #a3a4a4;
    background-color: #f5f6f6;
  }
}
</style>
